import React, { useState } from 'react';
import { listsViewStyles } from '../styles';
import {
    Box,
    Checkbox,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    withStyles
} from '@material-ui/core';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';

function CustomerFields({ classes, fields, setFields, description }) {
    const [dragIndex, setDragIndex] = useState(null);

    const formChanged = (updatedFields = fields) => {
        setFields(updatedFields);
    };

    const handleDragStart = index => () => {
        setDragIndex(index);
    };

    const handleDragOver = event => {
        event.preventDefault();
    };

    const handleCheckboxChange = (index, key) => event => {
        const updatedFields = [...fields];
        updatedFields[index][key] = event.target.checked;
        if (key === 'required' && event.target.checked) {
            updatedFields[index]['show'] = event.target.checked;
        }
        setFields(updatedFields);
        formChanged(updatedFields);
    };

    const handleDrop = dropIndex => () => {
        if (dragIndex === null || dragIndex === dropIndex) return;

        const updatedFields = [...fields];
        const [movedItem] = updatedFields.splice(dragIndex, 1);
        updatedFields.splice(dropIndex, 0, movedItem);
        setFields(updatedFields);
        setDragIndex(null);
        formChanged(updatedFields);
    };

    return (
        <Grid container direction="row" spacing={4}>
            <Grid item xs={12}>
                <Typography style={{ fontSize: 16 }}>{description}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                <Box className={classes.box}>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ width: 20, paddingRight: 0, marginRight: 0 }}></TableCell>
                                <TableCell></TableCell>
                                <TableCell>
                                    <strong>Show</strong>
                                </TableCell>
                                <TableCell>
                                    <strong>Required</strong>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {fields.map((field, index) => (
                                <TableRow
                                    key={field.name}
                                    draggable
                                    onDragStart={handleDragStart(index)}
                                    onDragOver={handleDragOver}
                                    onDrop={handleDrop(index)}
                                    style={{ cursor: 'move' }}
                                >
                                    <TableCell
                                        style={{
                                            width: 20,
                                            paddingRight: 0,
                                            marginRight: 0
                                        }}
                                    >
                                        <DragIndicatorIcon style={{ cursor: 'grab' }} />
                                    </TableCell>
                                    <TableCell>{field.label}</TableCell>
                                    <TableCell>
                                        <Checkbox
                                            checked={field.show}
                                            disabled={field.disabled}
                                            onChange={handleCheckboxChange(index, 'show')}
                                            color="primary"
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Checkbox
                                            checked={field.required}
                                            disabled={field.disabled}
                                            onChange={handleCheckboxChange(index, 'required')}
                                            color="primary"
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </Grid>
        </Grid>
    );
}

export default withStyles(listsViewStyles)(CustomerFields);
